"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _lodash = _interopRequireDefault(require("lodash.upperfirst"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.getRoles = getRoles, exports.getSelectedRole = getSelectedRole;

function getOptionFromRole(a) {
  var b = a.description;
  return {
    label: (0, _lodash["default"])(b.toLowerCase()),
    value: b
  };
}

function getRoles(a) {
  return a.filter(function (a) {
    var b = a.name;
    return "OWNER" !== b;
  }).map(getOptionFromRole);
}

function getSelectedRole(a, b) {
  if (!a || !a.name) return null;
  var c = b.find(function (b) {
    var c = b.name;
    return c === a.name;
  });
  return c ? getOptionFromRole(c) : null;
}